<template>
  <div id="background">
    <div id="container">
      <li v-bind:key=service.category v-for="service in services">
          <h3 is="sui-header" class="center" block>
            {{ service.category }}
          </h3>
          <sui-card-group :items-per-row="service.itemsPerRow">
            <card :header=content.header :link=content.link :description=content.description :pricing=content.pricing v-bind:key=content.link v-for="content in service.content" />
          </sui-card-group>
      </li>
    </div>
  </div>
</template>

<script>
import Card from '../components/Card.vue'

export default {
  name: 'resources',
  components: {
    Card
  },
  computed: {
    console: () => console
  },
  data: () => {
    return {
      services: [{
        category: 'E2E & Component Testing, Debugging & Analytics',
        itemsPerRow: 2,
        content: [{
          header: 'QUnit',
          link: 'https://qunitjs.com/',
          description: 'The powerful, easy-to-use JavaScript testing framework.',
          pricing: 'MIT License'
        }, {
          header: 'QUnit-DOM',
          link: 'https://github.com/simplabs/qunit-dom',
          description: 'High level DOM assertions for QUnit. This package is useful if you\'re developing an application using EmberJS',
          pricing: 'MIT License'
        }, {
          header: 'Cypress',
          link: 'https://www.cypress.io/',
          description: 'Run tests interactively in your browser or headlessly in the terminal using Chai or other extensions',
          pricing: 'Free, with Premium Tiers'
        }, {
          header: 'Mezmo (formerly LogDNA)',
          link: 'https://www.mezmo.com/',
          description: 'Logging utilities for your production app.  With this service, you\'ll be able to monitor server-side tasks and client based interactions.',
          pricing: 'Premium'
        }, {
          header: 'Pino',
          link: 'https://getpino.io',
          description: 'Custom logging utility for your NodeJS application.  With this you can assign tags to your logs, color code them, etc.',
          pricing: 'MIT License'
        }, {
          header: 'ChaiJS',
          link: 'https://www.chaijs.com/',
          description: 'Chai is a BDD/TDD for NodeJS and the browser that can be paired with any JavaScript framework',
          pricing: 'MIT License'
        }]
      }, {
        category: 'Utility Services',
        itemsPerRow: 2,
        content: [{
          header: 'SendGrid',
          link: 'https://sendgrid.com/',
          description: 'Provides services for sending custom business emails to your clients',
          pricing: 'Free, with Premium Tiers'
        }, {
          header: 'NodeMailer',
          link: 'https://nodemailer.com/about/',
          description: 'You can use NodeMailer paired with SendGrid (or any other provider of your choice) to send emails via JavaScript',
          pricing: 'MIT License'
        }, {
          header: 'EmailTemplates',
          link: 'https://github.com/forwardemail/email-templates',
          description: 'SendGrid will send the emails, NodeMailer let\'s you do it using JavaScript, and EmailTemplates is what you can use to decorate your emails.',
          pricing: 'MIT License'
        }, {
          header: 'Fuse.js',
          link: 'https://fusejs.io/',
          description: 'Definitely one of the more useful packages out there if you want to implement a simple search feature in your application without having to set up a dedicated server for it.',
          pricing: 'Apache License'
        }, {
          header: 'PDF-Lib',
          link: 'https://pdf-lib.js.org/',
          description: 'JavaScript package for reading, writing, and saving PDF\'s',
          pricing: 'MIT License'
        }, {
          header: 'Crontab Guru',
          link: 'https://crontab.guru/',
          description: 'Used for scheduling service tasks on a server-side environment, i.e. sending email reminders to all your clients',
          pricing: 'Free, with Premium Tiers'
        }, {
          header: 'Bcrypt',
          link: 'https://github.com/kelektiv/node.bcrypt.js',
          description: 'Password hasher. Use this library to hash your passwords and compare a user-typed password to the hash, verifying that the password is correct',
          pricing: 'MIT License'
        }, {
          header: 'SheetJS',
          link: 'https://sheetjs.com/',
          description: 'Allows you to read, edit, and export spreadsheets in your web application',
          pricing: 'Apache License'
        }]
      }, {
        category: 'Frameworks & ORM\'s',
        itemsPerRow: 2,
        content: [{
          header: 'Sequelize',
          link: 'https://sequelize.org/',
          description: 'NodeJS and TypeScript ORM, allows you to interface with Oracle, Postgres, MySQL, MariaDB, SQLite and SQL Server',
          pricing: 'MIT License'
        }, {
          header: 'Prisma',
          link: 'https://www.prisma.io/',
          description: 'NodeJS and TypeScript ORM (Object Relational Model), recommended by NextJS, allows you to interface with a database of your choice, preferably MongoDB',
          pricing: 'Apache License'
        }, {
          header: 'NextJS',
          link: 'https://nextjs.org/',
          description: 'Serverless framework for your web application',
          pricing: 'MIT License'
        }, {
          header: 'AuthJS (Next-Auth)',
          link: 'https://next-auth.js.org/',
          description: 'Serverless framework',
          pricing: 'ISC License'
        }, {
          header: 'EmberJS',
          link: 'https://emberjs.com',
          description: 'Falls between React and Vue. Ember has a higher learning curve and is less popular, but does a great job keeping your application clean by clearly separating the view, model, and route.',
          pricing: 'MIT License'
        }, {
          header: 'Fastify',
          link: 'https://www.fastify.io/',
          description: 'NodeJS server for implementing your API routes and interacting with your database if setting up a serverless application isn\'t for you',
          pricing: 'MIT License'
        }]
      }]
    }
  }
}
</script>

<style>
#background {
  height: 100% !important;
  background-image: url('../assets/blueprint.svg');
  background-position: 5% 5%;
  background-size: 20%;
}

#container {
  background-color: #cce6dd;
  height: 100%;
  margin-left: 20%;
  margin-right: 20%;

  border-color: #6483c7;
  border-width: 7px;
  border-style: solid;
  border-bottom: none;
  border-top: none;

  overflow: visible;

  padding: 1em;

  background:
    radial-gradient(#46474a 3px, transparent 4px),
    radial-gradient(#4d4848 3px, transparent 4px),
    linear-gradient(#ffffff 4px, transparent 0),
    linear-gradient(45deg, transparent 74px, transparent 75px, #7057ff 75px, #d84d4d 76px, transparent 77px, transparent 109px),
    linear-gradient(-45deg, transparent 75px, transparent 76px, #7057ff 76px, #d84d4d 77px, transparent 78px, transparent 109px),
    #fff;
    background-size: 109px 109px, 109px 109px,100% 6px, 109px 109px, 109px 109px;
    background-position: 54px 55px, 0px 0px, 0px 0px, 0px 0px, 0px 0px;

  @media all and (max-width: 1000px) {
    margin-left: 0;
    margin-right: 0;
    border: none;
  }
}
</style>
